// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__tCIgw","tooltipContent":"Tooltip_tooltipContent__HLN6H","right":"Tooltip_right__Kok3b","below":"Tooltip_below__1OVb7"};